import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as upcomingAppointments from '../requests/appointments-upcomming-req';
import * as historyAppointments from '../requests/appointments-history-req';
import {
  selectHistoryAppointmentList,
  selectHistoryPagination,
  selectHistoryCount,
  selectUpcomingAppointmentList,
  selectUpcomingPagination,
  selectUpcomingCount,
} from '../selectors';

const targetData = {
  [upcomingAppointments.consts.LOAD_MORE]: {
    selectors: {
      pagination: selectUpcomingPagination,
      list: selectUpcomingAppointmentList,
      counter: selectUpcomingCount,
    },
    fetch: upcomingAppointments.paginationActions.send,
  },
  [historyAppointments.consts.LOAD_MORE]: {
    selectors: {
      pagination: selectHistoryPagination,
      list: selectHistoryAppointmentList,
      counter: selectHistoryCount,
    },
    fetch: historyAppointments.paginationActions.send,
  },
};

function* loadMoreAppointments({ type, payload }) {
  const { selectors, fetch } = targetData[type];
  const pagination = yield select(selectors.pagination);
  const counter = yield select(selectors.counter);
  const list = yield select(selectors.list);
  const listSize = size(list);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(fetch({ ...payload, ...pagination, offset: listSize }));
}

export default function* appointmentListPagination() {
  yield takeLatest(
    [
      upcomingAppointments.consts.LOAD_MORE,
      historyAppointments.consts.LOAD_MORE,
    ],
    loadMoreAppointments,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/appointment-list-pagination.js